module.exports = __webpack_public_path__ + "img/DE05683.a1043ce0.png";